import { render, staticRenderFns } from "./UploaderVideo.vue?vue&type=template&id=76a8c09c&scoped=true"
import script from "./UploaderVideo.vue?vue&type=script&lang=js"
export * from "./UploaderVideo.vue?vue&type=script&lang=js"
import style0 from "./UploaderVideo.vue?vue&type=style&index=0&id=76a8c09c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a8c09c",
  null
  
)

export default component.exports